/*
 * @Author: Huangxianlong
 * @Date: 2023-08-11 16:44:08
 * @LastEditors: Huangxianlong
 * @LastEditTime: 2026-01-26 12:15:02
 * @FilePath: \monitor\src\language\project\datalogger.js
 * @Description: 
 */
const info = {
  CN: {
    newDatalogger: "新建采集器",
    editDatalogger: "编辑采集器",
    newSensor: "新建传感器",
    editSensor: "编辑传感器",
    cancelBtn: "取消",
    saveBtn: "保存",
    initialize: "设定初值",
    initializeText: "除手动设定初值外，还有以下设定初值的方法：",
    initializeOne: "1. 当前的最新数据",
    initializeTwo: "2. 指定时间点之前最近数据",
    initializeThree: "3. 指定时间范围内的平均数据",
    initializeBtn: "获取并设定初值",
    initReadingRecord: "初值记录",
    timeNode: "时间节点",
    timeNodePla: "请选择时间节点",
    timeRange: "时间范围",
    timeRangePla: "请选择时间范围",
    initializeSuccess: "设定初值成功！",
    initializeFail: "设定初值失败！",
    initializeWarn: "暂无最新数据参考，请选择其他设定初值方式",
    typesFailed: "获取采集器类型列表失败！",
    cycleFailed: "获取采集器周期列表失败！",
    number: "序号",
    projectName: "项目名称",
    dataLoggerName: "采集器名称",
    dataloggerModel: "采集器型号",
    dataloggerDescription: "采集器描述",
    dataloggerType: "采集器类型",
    dataloggerStatus: "采集器状态",
    dataloggerInterval: "采集器周期",
    alertLevel: "告警级别",
    sensorId: "传感器编号",
    sensorName: "传感器名称",
    sensorDescription: "传感器描述",
    sensorStatus: "状态",
    normalStatus: "正常",
    warnStatus: "预警",
    alarmStatus: "告警",
    invalidStatus: "无效",
    operation: "操作",
    edit: "编辑",
    delete: "删除",
    open: "开启",
    close: "关闭",
    tips: "温馨提示",
    deleteTips: "<p>此操作会将该采集器下的数据表和传感器全部删除，请谨慎操作！删除操作不可恢复，是否继续删除该采集器？</p>",
    deleteTipsSensor: "删除操作不可恢复，是否继续删除该传感器？",
    deleteTipsGroup: "删除操作不可恢复，是否继续删除该分组？",
    deleteSuccess: "删除成功",
    deleteError: "删除失败",
    validWarnText: "必填信息不能为空",
    addSuccess: "添加成功",
    addError: "添加失败",
    saveSuccess: "保存成功",
    saveError: "保存失败",
    second: "秒",
    minute: "分钟",
    apiFailed: "请求数据失败",
    exportSuccess: "导出成功",
    calculationOne: "合成应变计算",
    calculationOneDescription: "μs=(μs₁+μs₂+...+μsₙ)/n",
    calculationTwo: "合成力计算",
    calculationTwoDescription: "KN=μs*P₁*P₂",
    calculationThree: "合成力计算（锚索计）",
    calculationThreeDescription: "",
    groupManagement: "分组管理",
    sensorImport: "传感器导入",
    newSensorGroup: "新增分组",
    groupName: "分组名称",
    cycle: "采集周期",
    maxNum: "最大位置序号",
    addGroup: "分组添加",
    editGroup: "分组编辑",
    excelImport: "请根据excel模板来填写相关信息来上传文件，提交后自动导入数据",
    submitUpload: "提交上传",
    downloadTemplate: "下载模板",
    uploadTip: "请上传文件",
    prompt1: "以下传感器(",
    prompt2: ")添加失败，其余传感器添加成功！",
    prompt3: "传感器添加成功！",
    remind: "表格数据不符合导入模板，请使用导入模板来导入传感器数据",
    noData: "导入的表格暂无数据",
    alarmParameters: "告警参数",
    selectFile: "选择文件",
    noFileSelected: "未选择任何文件",
    sensorNumWarn: "传感器有效个数不能大于传感器总数",
    categoryTips: "该区域下暂无该采集器类别，请到区域界面添加",
    setTime: "设定时间",
    dataloggerExists: "采集器名称已存在，添加失败!",
    noDataSelectedTime: "所选时间范围没有数据",
  },
  EN: {
    newDatalogger: "New Datalogger",
    editDatalogger: "Edit Datalogger",
    newSensor: "New Sensor",
    editSensor: "Edit Sensor",
    cancelBtn: "Cancel",
    saveBtn: "Save",
    initialize: "Initialize",
    initializeText: "In addition to manually setting the initial value, there are also the following methods for setting the initial value:",
    initializeOne: "1. Current latest data",
    initializeTwo: "2. Recent data before the specified time point",
    initializeThree: "3. Average data within a specified time range",
    initializeBtn: "Obtain and set initial values",
    initReadingRecord: "Initial value record",
    timeNode: "Time node",
    timeNodePla: "Please select a time node",
    timeRange: "Time range",
    timeRangePla: "Please select a time range",
    initializeSuccess: "Successfully set initial value!",
    initializeFail: "Failed to set initial value!",
    initializeWarn: "There is currently no latest data reference available. Please choose another initial value setting method",
    typesFailed: "Failed to obtain the list of datalogger types!",
    cycleFailed: "Failed to obtain datalogger cycle list!",
    number: "Number",
    projectName: "Project Name",
    dataLoggerName: "DataLogger Name",
    dataloggerModel: "Datalogger Model",
    dataloggerDescription: "Datalogger Description",
    dataloggerType: "Datalogger Type",
    dataloggerStatus: "Datalogger Status",
    dataloggerInterval: "Datalogger Interval",
    alertLevel: "Alarm Level",
    sensorId: "Sensor Id",
    sensorName: "Sensor Name",
    sensorDescription: "Sensor Description",
    sensorStatus: "Status",
    normalStatus: "normal",
    warnStatus: "warn",
    alarmStatus: "alarm",
    invalidStatus: "invalid",
    operation: "Operations",
    edit: "edit",
    delete: "delete",
    open: "open",
    close: "Close",
    tips: "Tips",
    deleteTips: "<p>This operation will delete all the data tables and sensors under the collector. Please be cautious! The deletion operation is not recoverable. Do you want to continue deleting this datalogger?</p>",
    deleteTipsSensor: "The deletion operation is irreversible. Do you want to continue deleting this sensor?",
    deleteTipsGroup: "The deletion operation is irreversible. Do you want to continue deleting this group?",
    deleteSuccess: "Successfully deleted",
    deleteError: "Delete failed",
    validWarnText: "Required information cannot be empty",
    addSuccess: "Added successfully",
    addError: "Add failed",
    saveSuccess: "Successfully saved",
    saveError: "Save failed",
    second: "second",
    minute: "minute",
    apiFailed: "Request for data failed",
    exportSuccess: "Export successful",
    calculationOne: "Synthetic strain calculation",
    calculationOneDescription: "μs=(μs₁+μs₂+...+μsₙ)/n",
    calculationTwo: "Composite force calculation",
    calculationTwoDescription: "KN=μs*P₁*P₂",
    calculationThree: "Composite force calculation (anchor cable meter)",
    calculationThreeDescription: "",
    groupManagement: "Group Management",
    sensorImport: "Sensor Import",
    newSensorGroup: "New Group",
    groupName: "Group Name",
    cycle: "cycle",
    maxNum: "Maximum Position Number",
    addGroup: "Group Addition",
    editGroup: "Group Editing",
    excelImport: "Please fill in the relevant information according to the Excel template to upload the file, and the data will be automatically imported after submission",
    submitUpload: "Submit Upload",
    downloadTemplate: "Download Template",
    uploadTip: "Please upload the file",
    prompt1: "The following sensors (",
    prompt2: ") failed to be added, while the other sensors were added successfully!",
    prompt3: "Sensor added successfully!",
    remind: "The table data does not match the import template. Please use the import template to import sensor data",
    noData: "The imported table currently has no data available",
    alarmParameters: "alarm parameters",
    selectFile: "Select File",
    noFileSelected: "No File Selected",
    sensorNumWarn: "The effective number of sensors cannot exceed the total number of sensors",
    categoryTips: "There is no datalogger category in this zone yet. Please add it in the zone interface",
    setTime: "Set time",
    dataloggerExists: "Datalogger name already exists, add failed!",
    noDataSelectedTime: "No data available for the selected time range",
  }
};
export default info; //需要暴露出去



// WEBPACK FOOTER //
// ./src/language/project/datalogger.js